import { observer } from "mobx-react"

import { AgentAccess } from "src/components/AgentSelection"
import { LibraryInformationItemStore } from "src/modals/library-information-items/store"
import { useStore } from "src/store/lib/useStore"

export const LibraryInformationItemsAgentAccess = observer(() => {
    const store = useStore(LibraryInformationItemStore)

    return <AgentAccess store={store} />
})
